<template>
  <div class="b">
    <Nav current="我的公司"></Nav>
    <div class="titleBox">
      <span class="txt l">编号</span>
      <div class="reviewDetail">
        <!-- v-if="treeBtn.add" -->
        <el-button
          type="primary"
          size="small"
          
          class="edit l bgBtn"
          @click="addHandle"
          >添加编号</el-button
        >
        <el-button type="primary add" style="background:#6CBFF7;" size="small" class="edit l bgBtn" @click="exportNumber('add')" >批量添加编号</el-button>
        <el-button type="primary update" style="background:#6CBFF7;" size="small" class="edit l bgBtn" @click="exportNumber('update')" >批量更新编号</el-button>
        
        <el-button
          type="primary"
          size="small"
          style="background:#FFBA1A;"
          class="edit l bgBtn" 
          @click="addRole"
          >添加新角色</el-button
        >
        <el-button
          type="primary"
          size="small"
          class="edit l bgBtn"
          @click="bacthHandle"
          >批量修改角色</el-button
        >
        <el-button type="primary" size="small" style="background:#55C4B8;" class="edit l bgBtn" @click="exportData"
          >导出编号</el-button
        >
        <el-button type="primary" size="small" style="background:#55C4B8;" class="edit l bgBtn" @click="historyRouter"
          >编号导入历史</el-button
        >
        <div></div>
      </div>
    </div>
    <div class="seatch">
      <div><span>编号:</span> <input type="text" v-model="List.name" /></div>
      <div><span>姓名:</span> <input type="text" v-model="List.alias" /></div>
      <div><span>电话:</span> <input type="text" v-model="List.mobile" /></div>
      <div>
        <span>部门:</span> <input type="text" v-model="List.departmentName" />
      </div>
      <div>
        <span>角色:</span> <input type="text" v-model="List.roleName" />
      </div>
      <div style="display:flex;">
        <span>状态:</span>
        <select @change="changeProduct($event)">
          <option></option>
          <option
            v-for="(item, index) in selectList"
            :key="index"
            :value="item.id"
          >
            {{ item.name }}
          </option>
        </select>
        <span class="el-icon-search" @click="getTableHeight('search')"></span>
      </div>
    </div>

    <div class="el-table-box">
      <el-table
        v-loading="isTableLoading"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        :data="tableData"
        :empty-text="emptyText"
        :style="{'width': '100%','min-height': '200px'}"
        :height="tableHeight ? tableHeight : 0"
      >
        <el-table-column
            prop="orderNum"
            label="序号"
            :fixed="true"
            width="100"
        >
        <template slot-scope="scope">
            {{ (currentPage - 1) * pageSize + scope.$index + 1 }}
          </template>
        </el-table-column> 

        <el-table-column
          :prop="col.prop"
          :label="col.label"
          :min-width="col.minwidth"
          :width="col.width"
          :fixed="col.fixed"
          :type="col.type"
          v-for="(col, index) in displayListCol"
          :key="index"
        >
          <template slot-scope="scope">
            <div v-if="col.prop!=='roleName' && col.prop!=='shadowTokenSignal'">
              {{ scope.row[col.prop] }}
            </div>
            <div v-else-if="col.prop==='shadowTokenSignal'">
              {{ scope.row[col.prop] === 'true' ? '第三方' : '很能猜' }}
            </div>
            <div v-else class="cursor-pointer" @click="showRoleModel(scope)">
              {{ scope.row[col.prop] ? `${scope.row[col.prop]} >` : '' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <!-- v-if="treeBtn.edit" -->
            <div v-if="treeBtn.edit" class="link-btn border-right l" @click="editHandle(scope.row)">
              编辑
            </div>
            <div
              class="link-btn l"
              v-if="treeBtn.delete"
              :style="(switchboardIdentity.switchboard_identity_id === scope.row.id || scope.row.type == 2) ? 'color: #ccc' : ''"
              v-show="stopshow(scope.row)"
              @click="outNumber(scope.row)"
            >
              停用
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div v-show="!isTableLoading" class="common-flex" style="margin-top: 20px ;  text-align: center;">
       
        <el-pagination
          v-cloak
          class="common"
          background
          :layout="paginationLayout"
          :total="total"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :name="name"
          :page-sizes="[5, 10, 30, 50, 70, 100]"
          prev-text="上一页"
          next-text="下一页"
          @size-change="changePageSize"
          @current-change="(val) => pageChange(val)"
          :class="!isPaginationUp ? 'pagination-down' : ''"
        >
        </el-pagination>
         <!-- 上一页 -->
        <div @click="pageChange(currentPage - 1)" style="padding:0!important"  v-if="!isPaginationUp && currentPage != 1" data-v-4519ba4a="" class="common el-pagination is-background" name="">
          <button type="button" style="margin-right: 0!important;" class="btn-prev active"><span>上一页</span></button>
        </div>
        <div @click="pageChange(currentPage)" style="padding:0!important"  v-if="!isPaginationUp && !isFinished" data-v-4519ba4a="" class="common el-pagination is-background" name="">
          <ul class="el-pager"><li class="number active">{{ currentPage }}</li><!----><!----><!----></ul>
        </div>
        
        <!-- 下一页 -->
        <div @click="pageChange(currentPage + 1)" style="padding:0!important" v-if="!isPaginationUp && !isFinished" data-v-4519ba4a="" class="common el-pagination is-background" name="">
          <button type="button" style="margin-left: 0!important;" class="btn-next active"><span>下一页</span></button>
        </div>
        

        <!-- 加载中 start -->
        <div v-loading="paginationIsLoading" class="common-flex" element-loading-background="transparent" element-loading-spinner="el-icon-loading" :style="{with:paginationIsLoading ? '30px' : '','margin-top': '25px'}"></div>
        <!-- 加载中 end -->

        <div class="common-pagination-dots-box common-flex" v-if="!isPaginationUp && !paginationIsLoading && !isFinished" @click="paginationToggle">
          <span class="dot"></span><span class="dot"></span><span class="dot"></span>
        </div>
      </div>
    </div>

    <div class="ec_tip exports none" ref="none">
      <div class="ec-title-out">
        温馨提示 <span id="close" @click="disappears">x</span>
      </div>
      <div class="ec-cont">
        <p>确定要将编号状态停用吗?</p>
        <p>停用后可以将编号继续分配给其他人使用!</p>
      </div>
      <div class="ec-but Deactivate">
        <input type="button" value="停用" @click="deleHandle" />
        <input class="butOut" type="button" value="放弃" @click=" disappears" />
      </div>
    </div>

    <!-- 批量导出弹框 -->
    <div class="ec_tips  exports" ref="export" v-loading="loading">
      <div class="ec-title" v-if="numberTemplate== '1' | numberTemplate== '2'">批量{{type == 'update' ? '更新': '添加'}}编号 <a href="#"><span style="color:#fff;" id="close" @click="disappears"> x</span></a></div>
      <div class="ec-title" v-if="numberTemplate=='3'">温馨提示 <a href="#"><span style="color:#fff;" id="close" @click="disappears"> x</span></a></div>
        <div class="ec-but" v-if="numberTemplate == '1' ">
          <div class="moban"> 模板文件<el-button type="primary" class="download" v-if="type == 'add' "  @click="downloadAddExcel" style="width: 140px;  height: 40px; background: #00a8ec; border:#75c0b6 0px solid; ">下载模板文件</el-button>
          <el-button type="primary" class="download"  @click="exportData" v-if="type == 'update' " style="width: 140px;  height: 40px; background: #00a8ec; border:#75c0b6 0px solid; ">下载模板文件</el-button><span style="color:#FFAE00;">* 请下载模板，填写数据后导入</span></div>
          
           <div class="content moban">
                <p style="width: 80px;  height: 40px;line-height: 40px;">Excle文件 <span class="fileName" >{{fileName}}</span></p>
            </div>
      
          <div style="margin-top: 10px;">
          <p class="explain">说<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>明:</p>
          <p class="indent">
            <ul>
              <li>1、支持修改:
                <p>(1) 已经存在的编号可以修改 <span style="color:red;">姓名、部门、角色、备注。</span></p>
                <p>(2) 已经存在的编号可以设置手机号码(之前没有手机号码)。</p>
                <p>(3）可以新增编号(编号必须唯一)，【创建日(倒序)】、【使用者同意日】、【终止日】、【编号id】列不用填写。</p>
              </li>
              <li>2、重点解释:
                <p>(1) 【编号id】有值则认为已经存在的编号。</p>
                <p>(2）系统中的部门存在重复，则修改这个重复部门无效。</p>
              </li>
              <li>3、文件格式: 导入文件只支持.xls为后缀的excel文件。</li>
              <li>4、文件大小: excel文件必须小于5M。</li>
              <li>5、模板限制: <span style="color:red;">批导模板一定要从系统下载，不能使用之前的模板，否则数据不同步。</span>  </li>
            </ul>
          </p>
        </div>
        <el-upload
        v-if="type == 'add'"
            class="upload-demo"
            ref="upload"
            :limit = "10"
            action="/organizationstructure/switchboardIdentity/importExcel"
            :show-file-list="false"
            :file-list="fileList"
            :on-change="handlePreview"
            :on-remove="handleRemove"
            :on-success="handleAvatarSuccess"
            :on-error="handleAvatarError"
            :auto-upload="false">
   <el-button slot="trigger" class="el-btn " style="width: 140px;height:40px; border:1px solid #000; color:#000; background:#FFF;"  type="primary">选择文件</el-button>
 <a href="#s"><span style="color:#0190FE;" @click="historyRouter">导入历史</span></a>
  <el-button class="sub-btn btn" style="margin-left: 57px;" size="small" type="success" @click="submitUpload">导入</el-button>
  <input class="butOut" type="button" value="取消" @click="disappears"/>
        </el-upload>
        <el-upload
        v-if="type == 'update'"
            class="upload-demo"
            ref="upload"
            :limit = "10"
            action="/organizationstructure/switchboardIdentity/importExcelForUpdate"
            :show-file-list="false"
            :file-list="fileList"
            :on-change="handlePreview"
            :on-remove="handleRemove"
            :on-success="handleAvatarSuccess"
            :on-error="handleAvatarError"
            :auto-upload="false">
   <el-button slot="trigger" class="el-btn " style="width: 140px;height:40px; border:1px solid #000; color:#000; background:#FFF;"  type="primary">选择文件</el-button>
 <a href="#s"><span style="color:#0190FE;" @click="historyRouter">导入历史</span></a>
  <el-button class="sub-btn btn" style="margin-left: 57px;" size="small" type="success" @click="submitUpload">导入</el-button>
  <input class="butOut" type="button" value="取消" @click="disappears"/>
        </el-upload>
        </div>
        <!-- 导入成功 -->
        <div class="contentType" v-if="numberTemplate=='2' "> 
            <div style="color:#000;">导入成功，共 <span style="color:#0090FF;">{{num}}</span> 条数据</div>
            <div class="operation"><a href="#s"><span style="color:#0190FE;  ">导入历史</span></a>
            <el-button class="sub-btn btn hide" style="margin-left: 57px;" size="small" type="success" @click="disappears">确定</el-button></div>
        </div>
        <!-- 导入失败 -->
        <div class="contentType" v-if="numberTemplate=='3' "> 
            <div style="color:#000; margin:10px 0; color:#FF0000;">导入失败，请修改后重新上传！</div>
              <div class="errorText">
                <p v-for="item in errorMsgList" :key="item">{{item}}</p>
              </div>
            <div class="operation"><a href="#s"><span style="color:#0190FE;" @click="historyRouter">导入历史</span></a>
            <el-button class="sub-btn btn hide" style="margin-left: 57px;" size="small" type="success" @click="disappears">确定</el-button></div>
        </div>
    </div>    <!-- 蒙层 -->
    <div class="mask none  exports" ref="none"></div>
    <!-- 角色模态框 -->
    <el-dialog
      title="角色编号详情"
      v-if="centerDialogVisible"
      :visible.sync="centerDialogVisible"
      width="80%"
      center>
      <div class="role-dialog-content">
         <div class="role-header">
            <p>
              角色名称：
              <span>{{roleName}}</span>
            </p>
            <p style="margin-top:5px">
              共有 <span>{{totalRole}}</span>
              个编号在使用此角色，具体编号如下：
            </p>
         </div>
         <div style="margin-top:10px">
          <el-table
            :data="roleList"
            stripe
            style="width: 100%"
            header-row-class-name="hearder-row-class"
            cell-class-name="role-cell-class"
            :max-height="350"
          >
            <el-table-column
              prop="name"
              label="编号"
              width="180">
            </el-table-column>
            <el-table-column
              prop="alias"
              label="姓名"
              width="180">
            </el-table-column>
            <el-table-column
              prop="mobile"
              label="使用者电话">
            </el-table-column>
            <el-table-column
              prop="departmentName"
              label="部门">
            </el-table-column>
            <el-table-column
              prop="status"
              label="编号状态">
              <template slot-scope="scope">
                 {{ statusObj[scope.row.status] }}
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 20px ;  text-align: center;">
            <el-pagination
              background
              layout="total, sizes, prev, pager, next,jumper"
              :total="totalRole"
              :current-page="rolePageNo"
              :page-size="rolePageSize"
              :page-sizes="[5, 10, 30, 50, 70, 100]"
              @size-change="changeRolePageSize"
              @current-change="changeRoleCurrentSize"
            >
            </el-pagination>
          </div>
         </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="footer-btn" type="primary" @click="goToRoleSetting">角色权限设置</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="温馨提示"
      v-if="roleTipsVisible"
      :visible.sync="roleTipsVisible"
      width="20%"
      center>
      <div class="role-tips">
        当前角色已被删除
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="footer-btn" type="primary" @click="roleTipsVisible = false">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Nav from "@/components/Nav.vue";
import axios from "axios";
import apiData from "@/config/api";
import http from "@/config/httpConfig";
export default {
  // name: "HelloWorld",
  components: {
    Nav,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      isTableLoading:false, // 表格是否正在加载中
      roleTipsVisible: false,
      switchboardIdentity: {}, // lucina 2026/03/04 登录账号信息
      statusObj: {
        1:'等待同意',
        2:'使用中',
        3:'已拒绝',
        4:'已停用',
        5:'已废弃'
      },
      rolePageNo: 1,
      rolePageSize: 10,
      totalRole: 0,
      roleName: '',
      roleId: '',
      roleList:[],
      centerDialogVisible: false,
      loading:false,
      current: "我的公司",
      fileList: [],
      fileName: "未选择任何文件",
      handleForm: {
        files: "",
      },
      inputSize: "",
      numberTemplate: "1", //1.添加修改  2.导入成功  3.导入失败
      upLoadBtn: false,
      deleteObj: {},
      currentPage: 1,
      pageSize: 10,
      total: 0,
      num: "",
      name: "",
      type: "",
      errorMsg: "",
      errorMsgList: [],
      tableData: [],
      emptyText: " ",
      tableHeight: "", //表格高度
      paginationLayout:'',
      isPaginationUp:false,// 页码是否展开
      paginationIsLoading:false,// 页码是否正在加载中
      isFinished:false,// 是否加载完成
      minHeight:'0',
      listCol: [
        // {
        //   prop: "orderNum",
        //   label: "序号",
        //   width: "100",
        //   fixed: true,
        //   type: "index",
        // },
        {
          prop: "name",
          label: "编号",
          minwidth: "200",
          fixed: 'left',
        },
        {
          prop: "alias", //入库仓库
          label: "姓名",
          minwidth: "100",
        },
        {
          prop: "mobile",
          label: "使用者电话",
          minwidth: "150",
        },
        {
          prop: "status",
          label: "编号状态",
          minwidth: "120",
          ref: "status",
        },
        {
          prop: "departmentName",
          label: "部门",
          minwidth: "120",
          id: "departmentId",
        },
        {
          prop: "roleName",
          label: "角色",
          minwidth: "120",
        },
        {
          prop: "remark",
          label: "备注",
          minwidth: "120",
        },
        {
          prop: "shadowTokenSignal",
          label: "创建来源",
          minwidth: "120",
          ref: "status",
          hidden: false, // 控制是否显示此列
        },
        {
          prop: "userRole",
          label: "统计",
          minwidth: "120",
        },
        {
          prop: "createdAtShow",
          label: "创建日(倒序)",
          minwidth: "120",
        },
        {
          prop: "acceptedAtShow",
          label: "使用者同意日",
          minwidth: "120",
        },
        {
          prop: "stopAtShow",
          label: "终止日",
          minwidth: "120",
        },
      ],
      selectList: [
        { id: 1, name: "待同意" },
        { id: 2, name: "使用中" },
        { id: 3, name: "已拒绝" },
        { id: 4, name: "已停用" },
        { id: 5, name: "已废弃" },
      ],
      errorList: [
        {
          prop: "name",
          label: "编号",
          minwidth: "100",
        },
        {
          prop: "alias", //入库仓库
          label: "姓名",
          minwidth: "70",
        },
        {
          prop: "mobile",
          label: "使用者电话",
          minwidth: "100",
        },
        {
          prop: "departmentName",
          label: "部门",
          minwidth: "80",
          id: "departmentId",
        },
        {
          prop: "roleName",
          label: "角色",
          minwidth: "80",
        },
      ],
      statusId: "",
      List: {
        name: "",
        alias: "",
        mobile: "",
        roleName: "",
        status: "",
        departmentName: "",
        shadowTokenSignal: "",
      },
      switchboard_identity_id: "",
      HncToken: "",
      statusIndex: "",
      loadingInstance: "",
      exports: [],
      treeBtn: {
        add: false,
        edit: false,
        delete: false,
        pwd: false,
      },
    };
  },
  created() {
   if(this.$route.query.resoure){
      this.List = JSON.parse(sessionStorage.getItem('list'));
      this.roleName = sessionStorage.getItem('roleName');
      this.currentPage = Number(sessionStorage.getItem('currentPage'));
      this.pageSize = Number(sessionStorage.getItem('pageSize'))
    }
  },
  mounted() {
    this.getTableHeight(false);
    this.getHncToken();
    this.getSwitchboardIdentity(); // lucina 2026/03/04 获取登录账号信息
    this.exports = document.getElementsByClassName("exports");
    let listMenuAll = JSON.parse(localStorage.getItem("listMenu"));
    if (listMenuAll && listMenuAll.length) {
      for (let index = 0; index < listMenuAll.length; index++) {
        const listMenu = listMenuAll[index];
        if (listMenu.children) {
          this.navList = listMenu.children.map((itemOne) => {
            if (itemOne.level === "020101") {
              //编号
              itemOne["current"] = true;
              if (itemOne.children) {
                itemOne.children.forEach((item, index) => {
                  if (item.opCode === "user.add") {
                    this.treeBtn.add = true;
                  }
                  if (item.opCode === "user.edit") {
                    this.treeBtn.edit = true;
                  }
                  if (item.opCode === "user.delete") {
                    this.treeBtn.delete = true;
                  }
                  if (item.opCode === "user.pwd") {
                    this.treeBtn.pwd = true;
                  }
                });
              }
            }
            return itemOne;
          });
        }
      }
    }
  },

  computed: {
    displayListCol() {
      // 过滤出需要显示的列
      return this.listCol.filter(col => !col.hidden);
    }
  },
  methods: {
    goToRoleSetting(){
      sessionStorage.setItem('list', JSON.stringify(this.List))
      sessionStorage.setItem('roleName', this.roleName)
      sessionStorage.setItem('currentPage', this.currentPage)
      sessionStorage.setItem('pageSize', this.pageSize)
      this.$router.push({
        path:'/company/roleAuthority',
        query: {
          roleId: this.roleId,
          roleName: this.roleName,
          resoure: 1
        }
      })   
    },
    changeRolePageSize(val){
      this.rolePageNo = 1;
      this.rolePageSize = val;
      this.getRoleList(); 
    },
    changeRoleCurrentSize(val){
      this.rolePageNo = val;
      this.getRoleList(); 
    },
    getRoleList(){
      const params = {
        roleId: this.roleId,
        pageNum: this.rolePageNo,
        pageSize: this.rolePageSize,
      }
      http.get(apiData.numberList, true, params, (res) => {
        this.roleList = res.data.data.list
        this.totalRole = res.data.data.totalRow
        if(this.totalRole > 0){
          this.centerDialogVisible = true;
        }else{
          this.roleTipsVisible = true;
        }
         
      });
    },
    showRoleModel(scope){
      const { roleName, roleId } = scope.row;
      this.roleName = roleName;
      this.roleId = roleId;
      this.getRoleList();
    },
    historyRouter() {
      let _this = this;
      _this.$router.push("/company/importHistory");
    },
    submitUpload() {
      this.$refs.upload.submit();
      this.loading = true
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    // 上传和导入都会触发此函数
    handlePreview(file) {
      let _this = this;
      // 判断数组有对象存在时就删除掉再添加进去一个新的对象
      if (_this.fileList.length > 0) {
        _this.fileList.splice(0);
        //  var file = file
        _this.fileList.push(file);
        _this.fileName = _this.fileList[0].name;
      } else {
        _this.fileList = []
        // 没有对象就直接添加进去
        _this.fileList.push(file);
        _this.fileName = _this.fileList[0].name;
      }
    },

    // 导入成功后提示
    handleAvatarSuccess(res, file) {
      let _this = this;
      this.fileList = file;
      if (file.size > 5242880) {
        this.$nextTick(function () {
          this.$message({
            message: "每个文件不超过5M",
            type: "warning",
          });
        });

        return false;
      }
      if (res.code == 200) {
         
        this.$nextTick(function () {
          _this.$message.success(res.msg);
          _this.loading = false
        });
        _this.numberTemplate = "2";
        _this.num = res.data;
        _this.getTableHeight();
        _this.$refs.upload.clearFiles();
      } else if (res.code == 400) {
        _this.errorMsgList = [];
        _this.errorMsg = res.msg;
        _this.numberTemplate = "3";
        var str = _this.errorMsg.split("！");
        for (let i = 0; i < str.length; i++) {
         
          _this.errorMsgList.push(str[i]);

        }
         _this.loading = false
        //   this.$nextTick(function () {
        //   this.$message.error(res.msg);
        // });
      } else {
        if (res.msg) {
          _this.$message.error(res.msg);
        }
        _this.loading = false
      }

    },
    handleAvatarError(res, file) {
      let _this = this
      _this.numberTemplate = "3";
      _this.loading = false
      _this.$nextTick(function () {
        _this.$message.error(res.msg);
      });
      _this.loading = false
    },

    getHncToken() {
      let _this = this;
      _this.HncToken = this.getCookie("HncToken");
      _this.switchboard_identity_id = this.getCookie(
        "_login_switchboard_identity_id"
      );
      // alert(this.getCookie("_login_switchboard_identity_id"))
      // alert(this.getCookie("HncToken"))
    },
    exportData() {
      let _this = this;

      window.open(
        "/api/organizationstructure/switchboardIdentity/excelList?HncToken=" +
          _this.HncToken +
          "&switchboard_identity_id=" +
          _this.switchboard_identity_id +
          "&name=" +
          _this.List.name +
          "&alias=" +
          _this.List.alias +
          "&mobile=" +
          _this.List.mobile +
          "&roleName=" +
          _this.List.roleName +
          "&departmentName=" +
          _this.List.departmentName +
          "&status=" +
          _this.statusId
      );
    },
    // 获取cookie的值
    getCookie(name) {
      var arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
      else return null;
    },
    // lucina 2026/03/04 获取登录账号信息
    getSwitchboardIdentity() {
      let switchboardIdentity = localStorage.getItem("switchboardIdentity");
      if (switchboardIdentity) {
        this.switchboardIdentity = JSON.parse(switchboardIdentity);
      }
    },
    //下载添加编号模板
    downloadAddExcel() {
      axios({
        method: "get",
        header: { "Content-Type": "application/xls" }, // http请求类型
        responseType: "blob", // 返回格式，默认json，可选arraybuffer、blob、document、json、text、stream
        url: apiData.downloadTemplateExcel,
        params: { HncToken: localStorage.getItem("HncToken") },
      })
        .then((res) => {
          // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
          let blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
          });
          let downloadElement = document.createElement("a");
          let href = window.URL.createObjectURL(blob);
          downloadElement.href = href;
          downloadElement.download = "添加编号模板.xlsx"; // xxx.xls/xxx.xlsx
          document.body.appendChild(downloadElement);
          downloadElement.click();
          document.body.removeChild(downloadElement);

          window.URL.revokeObjectURL(href);
        })
        .catch((err) => {
          // this.$message.error("服务器连接错误！");
          this.$nextTick(function () {
            this.$message.error(res.msg);
          });
        });
    },
    //批量导入
    exportNumber(type) {
      let _this = this;
      _this.exports = document.getElementsByClassName("exports");
      // console.log(type, "导入");
      _this.type = type;
      for (let i = 0; i < _this.exports.length; i++) {
        _this.exports[i].style.display = "block";
      }
    },

    stopshow(row) {
      var isshow = false;
      // console.log(row.status);
      switch (row.status) {
        case "已停用":
          isshow = false;
          break;
        default:
          isshow = true;
          break;
      }
      return isshow;
    },
    changePageSize(val) {
      this.pageSize = val;

      this.getTableHeight();
    },
    changeCurrentSize(val) {
      this.currentPage = val;

      this.getTableHeight();
    },
    pageChange(val) {
      console.log('pageChange called with val:', val);
      console.log('currentPage before:', this.currentPage);
      this.currentPage = val;
      console.log('currentPage after:', this.currentPage);
      // 确保currentPage已经更新后再调用getTableHeight
      this.$nextTick(() => {
        this.getTableHeight();
      });
    },
    // searchTableData(){
    //   this.currentPage = 1;
    //   this.getTableHeight();
    // }, 
    getTableHeight(isSearch) {
      let _this = this;
      _this.isTableLoading = true
      _this.minHeight = isSearch ? 0 :'528px'
      
      this.$nextTick(function () {
        // this.clientHeight = `${document.documentElement.clientHeight}`;
        // let o = document.querySelector('.bg')
        // let searchHeight = o.clientHeight || o.offsetHeight;
        // let tableHeight = this.clientHeight - 130 - searchHeight;
        // this.tableHeight = 500 + "px";
        _this.$utils.getTableHeight(_this, 130)//搜索的高度+标题+margin
      });
      if (isSearch) {
        // debugger
        _this.currentPage = 1
        _this.paginationLayout = '' 
        _this.isPaginationUp = false 	
        _this.total = 0
      }
      let params = {
        name: _this.List.name,
        alias: _this.List.alias,
        mobile: _this.List.mobile,
        roleName: _this.List.roleName,
        status: _this.statusId,
        departmentName: _this.List.departmentName,
        pageNum: _this.currentPage,
        pageSize: _this.pageSize,
        isHideLoading:true
      };
      _this.emptyText = " ";
      http.get(apiData.numberList, true, params, (res) => {
        _this.isTableLoading = false
        if (res.data.code == 200) {
          // 根据 msg 字段判断是否显示【创建来源】列
          const showSourceColumn = res.data.msg === "true";
          
          if (!res.data.data.list) {
            _this.tableData = [];
          } else {
            _this.tableData = res.data.data.list;
          }
          let flag = (res.data.data.list && res.data.data.list.length) < _this.pageSize
          _this.isFinished = flag
         
          

          if (_this.tableData == null) {
          }
          for (let i = 0; i < _this.tableData.length; i++) {
            _this.tableData[i].shadowTokenSignal =
              _this.tableData[i].shadowTokenSignal.toString();
          }

          if (_this.tableData) {
            // 模拟数据
            // _this.total = res.data.data.totalRow;
            for (let i = 0; i < _this.tableData.length; i++) {
              if (_this.tableData[i].status == 5) {
                 _this.tableData[i].status = "已废弃";
              } else if (_this.tableData[i].status == 4) {
                _this.tableData[i].status = "已停用";
              } else if (_this.tableData[i].status == 3) {
                _this.tableData[i].status = "已拒绝";
              } else if (_this.tableData[i].status == 2) {
                _this.tableData[i].status = "使用中";
              } else {
                _this.tableData[i].status = "等待同意";
              }
            }
            
            // 根据接口返回的 msg 字段控制【创建来源】列的显示/隐藏
            const sourceColumn = _this.listCol.find(col => col.prop === 'shadowTokenSignal');
            if (sourceColumn) {
              // msg="true" 时显示，msg="false" 时隐藏
              sourceColumn.hidden = !showSourceColumn;
            }
            
            //  _this.$message.success(res.data.msg);
          }
        } else {
          _this.$message.error(res.data.msg);
        }
        _this.emptyText = "暂无数据";
      },(err) => {
        _this.isTableLoading = false
      });
    },
    editHandle(row) {
      let _this = this;
      if (row.status == "已废弃") {
        row.status = 5;
      } else if (row.status == "已停用") {
        row.status = 4;
      } else if (row.status == "已拒绝") {
        row.status = 3;
      } else if (row.status == "使用中") {
        row.status = 2;
      } else {
        row.status = 1;
      }
      this.$router.push({ name: "EditNumber", query: { id: row.id } });
    },
    outNumber(row) {
      let _this = this;
      
      // lucina 2026/03/04 停用账号时，判断是否是当前登录账号
      if (_this.switchboardIdentity.switchboard_identity_id === row.id) {
        _this.$message.warning("不能停用自己的编号");
        return;
      }
      // lucina 2026/03/09 停用账号时，判断是否是总账号
      if (row.type == 2) {
        _this.$message.warning("不能停用总账号");
        return;
      }

      _this.disabledList = document.getElementsByClassName("none");
      for (var i = 0; i < _this.disabledList.length; i++) {
        _this.disabledList[i].style.display = "block";
      }
      _this.deleteObj = row;
    },
    // 停用编号
    deleHandle() {
      var _this = this;
      for (var i = 0; i < _this.disabledList.length; i++) {
        _this.disabledList[i].style.display = "none";
      }
      http.put(apiData.outNumber, true, { id: _this.deleteObj.id }, (res) => {
        if (res.data.code == 200) {
          _this.getTableHeight();
          _this.$message.success("停用成功");
        } else {
          _this.$message.error("停用失败");
        }
      });
    },
    addHandle() {
      this.$router.push("/company/addNumber");
    },
    addRole() {
      this.$router.push("/company/addRole");
    },
    bacthHandle() {
      this.$router.push("/company/bacthRole");
    },

    changeProduct(event) {
      this.statusId = event.target.value; //获取option对应的value值
    },
    disappears() {
      let _this = this;
      //蒙层消失
      _this.numberTemplate = "1";
      for (var i = 0; i < _this.exports.length; i++) {
        _this.exports[i].style.display = "none";
      }
      _this.errorMsgList = [];
      _this.fileName = '未选择任何文件'
    },
    /**
    * @Author: lixiang
    * @description: 获取总数
    */			
		getCount(isGetList = false) { 
				let _this = this;
				let params = {
          name: _this.List.name,
          alias: _this.List.alias,
          mobile: _this.List.mobile,
          roleName: _this.List.roleName,
          status: _this.statusId,
          departmentName: _this.List.departmentName,
          pageNum: _this.currentPage,
          pageSize: _this.pageSize,
          isHideLoading:true
        };
				
				
        http.get(apiData.identityPageCount, true, params, (res) => {
          // 模拟数据
          _this.total = res.data.data.totalRow
          _this.paginationIsLoading = false
          _this.$utils.paginationToggle(_this)
        });
        
        if(isGetList){
            _this.getTableHeight()
        }
				
			},

			/**
			* @Author: lixiang
			* @description: 
			*/			
			paginationToggle(){
				let _this = this
        let isSearch =  Object.values(_this.List)?.some(item => item?.length > 0)
        // _this.currentPage = 1
        _this.paginationIsLoading = true
        _this.paginationLayout = ''
				_this.getCount((isSearch || _this.List.statusId) ? true : false)
				
			},
  },
  watch: {
		currentPage: {
			handler(newVal, oldVal) {
				if (newVal !== oldVal) {
					// 当currentPage改变时，将表格滚动到顶部
					this.$nextTick(() => {
						const tableElement = document.querySelector('.el-table__body-wrapper');
						if (tableElement) {
							tableElement.scrollTop = 0;
						}
					});
				}
			},
			// immediate: true
		}
	},
};
</script>
<style scoped lang="less">
.seatch {
  margin-left: 0;
}
.b {
  padding: 0 10px;
}

.titleBox {
  margin: 10px auto;
  margin-left: 10px;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  color: #333;

  .txt {
    display: inline-block;
    margin-right: 10px;
  }
}
.seatch {
  width: 100%;
  height: 30px;
  div {
    float: left;
    margin-right: 10px;
  }
  input {
    width: 120px;
    height: 30px;
    padding-left: 5px;
    margin-left: 5px;
  }
  select {
    width: 120px;
    height: 30px;
    margin-left: 5px;
    margin-right: 10px;
  }
  .el-icon-search {
    font-size: 20px;
  }
}
.content {
  display: flex;
}
/* 弹框 */
.ec_tip {
  width: 491px;
  height: 247px;
  display: none;
  position: absolute;
  left: 40%;
  top: 300px;
  background: #f8f8f8;
  color: #fff;
  z-index: 305;
  text-align: center;
}
//批量导入弹框
.ec_tips {
  width: 880px;
  height: 631px;
  display: none;
  position: absolute;
  left: 30%;
  top: 200px;
  background: #f8f8f8;
  color: #fff;
  z-index: 305;
  font-size: 16px;
  margin: 0 auto;

  .ec-but {
    color: #000;
    height: 100%;
    padding: 56px 20px 20px 66px;

    margin: 0 auto;
    p {
      text-align: left;
    }
    ul {
      width: 510px;
      li {
        width: 100%;
        margin-left: 70px;
        p {
          width: 480px;
          margin-left: 24px;
        }
      }
    }
  }
  .download {
    margin: 0 32px 0 67px;
  }
  .fileName {
    line-height: 40px;
    position: absolute;
    left: 368px;
    padding-left: 10px;
  }
  .upload-demo {
    height: 40px;
    margin-top: 39px;
    line-height: 40px;
  }
  .ec-cont {
    padding: 20px;
    .indent {
      // float: right;
      width: 511px;
      // margin: -17px 10px 0 0;

      p {
        width: 480px;
        margin-left: 24px;
      }
    }

    .explain {
      margin: 10px 0;
      width: 80px;
      line-height: 40px;
    }
    .el-button {
      margin: -6px 5px 0 17px;
    }
    .el-upload__tip {
      float: right;
    }
  }
}
.moban {
  margin: 0 0 10px 0;
}
.btn {
  background: #75c0b6;
  border: #75c0b6;
}
.el-btn {
  position: absolute;
  top: 144px;
  left: 197px;
  width: 140px;
  height: 40px;
}
.btn:hover {
  background: #75c0b6;
  border: #75c0b6;
}
.sub-btn {
  width: 200px;
  height: 40px;
  background: #75c0b6;
  border: #75c0b6;
  padding: 0;
}
.ec-cont-text {
  display: flex;
  margin-bottom: 10px;
}
.ec-title-out {
  width: 491px;
  height: 40px;
  background-color: #75c0b6;
  text-align: center;
  line-height: 40px;
  position: relative;
  margin: 0 auto;
  span {
    width: 20px;
    height: 20px;
    display: block;
    line-height: 16px;
    border: 1px solid #fff;
    border-radius: 50%;
    float: right;
    margin: 10px 10px 0 0;
  }
}
.ec-title {
  width: 100%;
  height: 40px;
  background-color: #75c0b6;
  text-align: center;
  line-height: 40px;
  position: relative;
  margin: 0 auto;
}
.ec-title span {
  width: 20px;
  height: 20px;
  display: block;
  line-height: 16px;
  border: 1px solid #fff;
  border-radius: 50%;
  float: right;
  margin: 10px 10px 0 0;
}

.daoru,
.daoru:hover {
  width: 200px;
  height: 40px;
  margin-left: 20px;
  float: left;
  border-radius: 5px;
  background: #75c0b6;
  border: 1px solid #75c0b6;
}
.ec-but input {
  width: 200px;
  height: 40px;
  margin-left: 20px;
  // float: left;
  border-radius: 5px;
  background-color: #fff;
}
.ec-cont {
  padding: 20px 0 0 0px;
  color: #000;
  // display: flex;
  // margin-left: 15px;
  input {
    width: 363px;
    height: 30px;
    padding: 4px 6px 4px 5px;
    border: 1px solid #ccc;
    text-align: center;
  }
  i {
    width: 30px;
    height: 30px;
    font-size: 25px;
    margin-top: 2px;
    display: block;
    margin-left: 5px;
    color: #ccc;
  }
}
.mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  display: none;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 304;
}
.butOut {
  color: #75c0b6;
  border: 1px solid #75c0b6;
}
.butOut:hover {
  background: #75c0b6;

  color: #fff;
}
.ec-but input:first-child {
  color: #fff;
  background-color: #75c0b6;
  border: 1px solid #75c0b6;
}

.active {
  background-color: #eee;
}
.demo-dynamic {
  margin: -6px 0 0 10px;
}
.Deactivate {
  position: absolute;
  bottom: 20px;
  left: 14px;
}
// 导入成功后弹框样式
.contentType {
  padding: 40px;
}
.operation {
  position: absolute;
  bottom: 50px;
}
.hide {
  margin-left: 145px !important;
}
.errorText {
  max-height: 380px;
  overflow-y: auto;
  color: red;
  padding: 5px 0 0 66px;
  box-sizing: border-box;
}
.cursor-pointer{
  cursor: pointer;
}
/deep/ .el-dialog__header{
  padding: 0 10px;
  height: 40px;
  line-height: 40px;
  background-color: #75c0b6;
  .el-dialog__title{
    color: #fff;
  }
  .el-dialog__headerbtn{
    border-radius: 50%;
    border: 1px solid #fff;
    top: 10px;
    right: 10px;
    width: 20px;
    height: 20px;
    .el-dialog__close{
      color: #fff;
    }
  }
}
.footer-btn{
  width: 200px;
  height: 40px;
  background-color: #75c0b6;
}
.role-dialog-content{
   .role-header{
    width: 100%;
    height: 58px;
    background: #F8F8F8;
    border-radius: 8px 8px 8px 8px;
    padding: 10px 30px;
    p{
      font-size: 14px !important;
      color: #666666 !important;
      font-weight: normal;
      span{
        color: #75c0b6;
        font-weight: 600;
      }
    }
   }
}
/deep/ .hearder-row-class{
  th{
    background: #EBEBEB !important;
  }
  
}
// /deep/ .el-table td, .el-table th.is-leaf{
//   border: none;
// }
/deep/ .role-cell-class{
  font-weight: 400;
  color: #666666;
}
// /deep/ .el-table::before{
//   height: 0;
// }
/deep/ .el-dialog__body {
    max-height: 530px;
    overflow: auto;
}
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #75c0b6;
}
/deep/ .el-button--primary{
  border: none;
}
/deep/ .el-table td, .el-table th{
  background: #fff!important;
}
.role-tips{
  width: 100%;
  text-align: center;
}
.pagination-dots-box {
  justify-content: center;
  padding-top: 10px;
  .dot {
    width: 6px;
    height: 6px;
    background: #ccc;
    border-radius: 50%;
    margin: 0 3px;
  }
}
</style>